var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAiIndicatorDot(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_ai_indicator_dot)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "url(#paint0_ai_indicator_dot)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27059 7.8624C4.14201 8.15484 4.83605 8.8522 5.12528 9.72791C5.17908 9.8902 5.32982 10 5.50027 10C5.67071 10 5.82092 9.89073 5.87525 9.72791C6.16502 8.85166 6.85853 8.15484 7.72994 7.8624C7.89134 7.8083 8 7.65673 8 7.48588C8 7.31502 7.89134 7.16344 7.72941 7.10881C6.858 6.81744 6.16502 6.12008 5.87472 5.24383C5.76659 4.91872 5.23288 4.91872 5.12528 5.24383C4.83552 6.12008 4.14201 6.81691 3.27059 7.10881C3.10919 7.16291 3 7.31448 3 7.48588C3.00053 7.65673 3.10919 7.8083 3.27059 7.8624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7269 8.60458C12.093 8.39228 11.5892 7.88427 11.378 7.24574C11.2688 6.91809 10.7301 6.91809 10.6215 7.24574C10.4108 7.88427 9.90646 8.39174 9.2726 8.60458C9.10968 8.65928 9 8.81255 9 8.98585C9 9.15862 9.10968 9.31189 9.27311 9.36713C9.90646 9.57943 10.4108 10.0869 10.6215 10.7254C10.6758 10.8895 10.8279 11 11 11C11.1721 11 11.3237 10.8895 11.3785 10.7254C11.5892 10.0869 12.0935 9.57943 12.7269 9.36713C12.8898 9.31243 13 9.15916 13 8.98585C12.9995 8.81309 12.8898 8.65982 12.7269 8.60458Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_ai_indicator_dot",
    x1: 0,
    y1: 0,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6467EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E30E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_ai_indicator_dot"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIndicatorDot);
export default __webpack_public_path__ + "static/media/ai-indicator-dot.29f83370.svg";
export { ForwardRef as ReactComponent };